import { useMemo } from 'react';

export const useStatesValues = (fieldName, countries) => {
  const getState = (fieldName, countries) => {
    let states = [];
    if (fieldName && countries.some(c => c.code === fieldName.value)) {
      states = countries.find(c => c.code === fieldName.value).states;

      return states?.map(state => ({
        value: state.code,
        label: state.name,
      }));
    }
    return states;
  };

  const useStateValues = useMemo(() => {
    return getState(fieldName, countries);
  }, [fieldName, countries]);
  return useStateValues;
};

export default useStatesValues;
